import { render, staticRenderFns } from "./ListResultInfo.vue?vue&type=template&id=72b8bbd0&scoped=true&"
import script from "./ListResultInfo.vue?vue&type=script&lang=ts&"
export * from "./ListResultInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ListResultInfo.vue?vue&type=style&index=0&id=72b8bbd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b8bbd0",
  null
  
)

export default component.exports